export const getTabOptions = (translate) => {
    const tabsOptions = [
        {
            title: translate('ABB.Powertrain.Frontend.gatewayManagementSmartSensorDCULabel'),
            route: '/smart-sensor-dcu',
            eventLogType: 'Gateway'
        },
        {
            title: translate('ABB.Powertrain.Frontend.gatewayManagementSmartSensorLabel'),
            route: '/smart-sensor',
            eventLogType: 'SmartSensor'
        },
        {
            title: translate('ABB.Powertrain.Frontend.gatewayManagementAPPLabel'),
            route: '/app',
            eventLogType: 'App'
        },
        {
            title: translate('ABB.Powertrain.Frontend.gatewayManagementDriveDCULabel'),
            route: '/drive-dcu',
            eventLogType: 'DriveGateway'
        }
    ];

    return tabsOptions;
};


